import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Wraps a ByteSource and counts every read — the number the UI shows to make
 * the selective-fetch behaviour (decision 0041) visible: a pack opens after
 * kilobytes, not after the whole zip.
 */
export var MeteredByteSource = /*#__PURE__*/function () {
  function MeteredByteSource(inner, onChange) {
    _classCallCheck(this, MeteredByteSource);
    _defineProperty(this, "current", {
      reads: 0,
      bytesRead: 0,
      totalSize: null,
      degraded: false
    });
    _defineProperty(this, "listeners", new Set());
    this.inner = inner;
    if (onChange) this.listeners.add(onChange);
  }
  return _createClass(MeteredByteSource, [{
    key: "stats",
    get: function get() {
      return _objectSpread(_objectSpread({}, this.current), {}, {
        degraded: this.inner.degraded === true
      });
    }
  }, {
    key: "degraded",
    get: function get() {
      return this.inner.degraded === true;
    }

    /** Observe stat changes (for the UI's fetch meter). Returns unsubscribe. */
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this.listeners.add(cb);
      return function () {
        return _this.listeners["delete"](cb);
      };
    }
  }, {
    key: "notify",
    value: function notify() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cb = _step.value;
          cb(this.stats);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "size",
    value: function () {
      var _size = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
        var n;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.inner.size(opts);
            case 1:
              n = _context.sent;
              if (this.current.totalSize !== n) {
                this.current.totalSize = n;
                this.notify();
              }
              return _context.abrupt("return", n);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function size(_x) {
        return _size.apply(this, arguments);
      }
      return size;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(offset, length, opts) {
        var b;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.inner.read(offset, length, opts);
            case 1:
              b = _context2.sent;
              this.current.reads += 1;
              this.current.bytesRead += b.length;
              this.notify();
              return _context2.abrupt("return", b);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function read(_x2, _x3, _x4) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }]);
}();